import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateUserkeyword } from 'store/actions/account';
import { makeStyles } from '@mui/styles';

import {  POSListToolbar, POSTable } from './components';


import CircularProgress from '@mui/material/CircularProgress';
import { Alert } from "@mui/material";

import { getAllDevices } from "apis/devicesAPIs";
import {
  useQuery,

} from "@tanstack/react-query";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },
  content: {
    marginTop: theme.spacing(2)
  },
  uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	}
}));


const POSList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // The search filter in the store is shared by all list pages, while the search
  // box starts empty; clear it so a search typed on another page doesn't hide rows.
  useEffect(() => {
    dispatch(updateUserkeyword(""));
  }, [dispatch]);
  

  const { isLoading, isFetching, isError, data, error, refetch } = useQuery({
    queryKey: ["deviceList"],
    queryFn: getAllDevices,
    refetchOnMount: "always",
  });

  
  if (isError) {
    return <Alert severity="error">{`${error.message} `}</Alert>;
  }



  if (isLoading === true) {
    return (
      <main className={classes.content}>
        {isLoading && <CircularProgress size={150} className={classes.uiProgess} />}
      </main>
    );
  } else {

  return (
    <div className={classes.root}>
      <POSListToolbar onRefresh={refetch} isRefreshing={isFetching} />
      <div className={classes.content}>
        {data ? (
        <POSTable deviceList={data} />
      ): null}
      </div>
    </div>
  );
  }
};

export default POSList;
